// extracted by mini-css-extract-plugin
export default {"component":"E8wfK"};